import App from '@/App.vue'
import router from '@/router'
import i18n from '@/i18n'
import { createPinia } from 'pinia'
import { Lazyload, setToastDefaultOptions } from 'vant'
import { useSystemInfo, useUserInfo } from '@/store'
import { persistedState } from '@/store/plugins/persist'
// import { PWALoginIframe } from '@/hooks/usePWAJumpIframe'
import { isInIframe, isInAndroidApp } from '@/env'
import { ev } from './consts'
import { createLog } from './api/theme'
import { saveUserNameAndPassword } from '@/utils'

const app = createApp(App)

const pinia = createPinia()
pinia.use(persistedState)
app.use(pinia)
app.use(i18n)
app.use(router)
app.use(Lazyload)

app.config.errorHandler = (err, instance, info) => {
  createLog({
    error:err,
    // instance,
    info,
  })
  console.error('errorHandler', err, instance, info)
}

setToastDefaultOptions({
  forbidClick: true,
  zIndex: 999,
  wordBreak: 'break-word',
})

app.config.performance = true

ev.on('login', () => {
  const userInfo = useUserInfo().userInfo!
  if (isInIframe) {
    userInfo.un_flag = localStorage.getItem('un_flag')
    userInfo.ps_flag = localStorage.getItem('ps_flag')
    window.parent.postMessage(
      // 通知主PWA登录成功
      {
        type: 'LOGIN',
        payload: {
          userInfo: JSON.stringify(userInfo),
        },
      },
      '*',
    )
  }

  if (isInAndroidApp) {
    window.jsBridge.postMessage('setSession', JSON.stringify(userInfo))
  }
})

ev.on('restore', (d: any) => {
  // console.log('on restore', d, d[0].userInfo, d[0].userInfo?.token)
  if (d[0].userInfo && d[1].$id === 'userInfo')
    useUserInfo().login(d[0].userInfo, d[0].userInfo?.token, true)
})

ev.on('logout', () => {
  // console.log('on logout')
  if (isInIframe) {
    // 通知主PWA登出
    window.parent.postMessage({ type: 'LOGOUT' }, '*')
  }

  if (isInAndroidApp) {
    // 通知安卓登出
    window.jsBridge.postMessage('setSession', '')
  }
})

if (!isInIframe) {
  window.addEventListener('message', async (event: any) => {
    const { type, payload } = event.data
    if (!type) return

    let info: any = null
    try {
      info = JSON.parse(payload.userInfo)
    } catch (e) { }
    // console.log('登录成功----------', type, info)
    if (type === 'LOGIN' && info) {
      // 主PWA登录
      useUserInfo().login(info, info.token)
      saveUserNameAndPassword(info.un_flag, info.ps_flag)
    }

    if (type === 'LOGOUT') {
      // 主PWA登出
      useUserInfo().logout()
    }
    // 刷新页面
    if (type === 'RELOAD') {
      // 主PWA登出
      location.reload()
    }
    if (type === 'requestClipboardRead') {
      // 获取剪贴板文本
      const text = await navigator.clipboard.readText()
      event.source.postMessage(
        {
          type: 'clipboardData',
          payload: text,
        },
        '*',
      )
    }

    if (type === 'REQUEST_AUTH') {
      // 初始化认证
      const un_flag = localStorage.getItem('un_flag')
      const ps_flag = localStorage.getItem('ps_flag')
      event.source.postMessage(
        {
          type: 'CLAIM_AUTH',
          payload: {
            un_flag: un_flag,
            ps_flag: ps_flag,
          },
        },
        '*',
      )
    }
  })
}

useUserInfo().checkToLogin()

const systemInfo = useSystemInfo()
systemInfo.$subscribe((_, state) => {
  i18n.global.locale = state.language as 'en' | 'pt'

  if (
    router.currentRoute.value.path !== '/maintain' &&
    state.merchantConfig &&
    state.merchantConfig.siteStatus !== 'Normal'
  ) {
    router.replace('/maintain')
  }

  if (
    router.currentRoute.value.path == '/maintain' &&
    state.merchantConfig &&
    state.merchantConfig.siteStatus === 'Normal'
  ) {
    router.replace('/')
  }
})

systemInfo
  .init()
  .then(() => {
    app.mount('#app')

    const { theme, skin } = useSystemInfo()
    document.body.dataset.theme = theme
    document.body.dataset.skin = skin
  })
  .catch((e) => {
    const { t } = i18n.global
    showDialog({
      title: t('InitDialog.title'),
      message: t('InitDialog.message'),
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: t('InitDialog.confirmButtonText'),
      className:
        'initfailed-dialog pointer-events-auto [&_*]:pointer-events-auto',
      theme: 'round-button',
      // teleport:'body',
      beforeClose: (action) => {
        console.log('beforeClose:', action)
        if (action === 'confirm') {
          location.reload()
        }
      },
    })

    document.body.classList.add('defaultBg')
    console.error('init error', e)
  })